<template>
  <div v-if="activeButtons" class="page-functions">
    <ul
      class="page-functions__list"
      :class="[
        orientation === 'h'
          ? 'page-functions__list--horizontal'
          : 'page-functions__list--vertical',
        `page-functions__list--align-${align}`,
      ]"
    >
      <li v-if="activeButtons.print" class="page-functions__item">
        <el-tooltip effect="light" content="Print" placement="top">
          <el-button class="page-functions__button" @click="printPage">
            <Icon :icon="'print'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.pdfDownload"
        class="page-functions__item"
        :class="
          showLabels ? 'page-functions__item--labeled' : 'page-functions__item'
        "
      >
        <!-- <el-tooltip v-if="downloadEnabled" effect="light" content="Download PDF" placement="top">
          <el-button class="page-functions__button" @click="pdfDownload">
            <Icon :icon="'pdf-download'" />
            <div class="button-label" v-if="showLabels">Download (PDF)</div>
          </el-button>
        </el-tooltip>
        <el-tooltip v-else effect="light" content="Please save the report to download." placement="top">
          <el-button class="page-functions__button" @click="pdfDownload">
            <Icon :icon="'pdf-download'" />
            <div class="button-label" v-if="showLabels">Download (PDF)</div>
          </el-button>
        </el-tooltip> -->
        <el-tooltip
          effect="light"
          :content="
            downloadEnabled
              ? 'Download PDF'
              : 'Please save the report to download.'
          "
          placement="top"
        >
          <el-button
            class="repDownload"
            :class="
              downloadEnabled
                ? 'page-functions__button'
                : 'page-functions__button--disabled'
            "
            @click="pdfDownload"
          >
            <Icon :icon="'pdf-download'" />
            <div v-if="showLabels" class="button-label">Download (PDF)</div>
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.excelDownload"
        class="page-functions__item"
        :class="
          showLabels ? 'page-functions__item--labeled' : 'page-functions__item'
        "
      >
        <!-- <el-tooltip v-if="downloadEnabled" effect="light" content="Download Excel" placement="top">
          <el-button class="page-functions__button" @click="excelDownload">
            <Icon :icon="'xlsx-download'" />
            <div class="button-label" v-if="showLabels">Download (Excel)</div>
          </el-button>
        </el-tooltip> -->
        <el-tooltip
          effect="light"
          :content="
            downloadEnabled
              ? 'Download Excel'
              : 'Please save the report to download.'
          "
          placement="top"
        >
          <el-button
            class="repDownload"
            :class="
              downloadEnabled
                ? 'page-functions__button'
                : 'page-functions__button--disabled'
            "
            @click="excelDownload"
          >
            <Icon :icon="'xlsx-download'" />
            <div v-if="showLabels" class="button-label">Download (Excel)</div>
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.emailToContact"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip
          effect="light"
          content="Send email to contacts"
          placement="top"
        >
          <el-button class="page-functions__button" @click="emailToContact">
            <Icon :icon="'email'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.bookmark"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip effect="light" content="Add to Bookmarks" placement="top">
          <el-button class="page-functions__button" @click="checkBookmark">
            <Icon v-if="!isBookmark" :icon="'bookmark'" />
            <Icon v-else :icon="'bookmark-full'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.emailToAuthor && articleAuthor"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip
          effect="light"
          content="Send email to author"
          placement="top"
        >
          <el-button class="page-functions__button" @click="emailToAuthor">
            <Icon :icon="'write-email'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.copy"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip effect="light" content="Copy" placement="top">
          <el-button class="page-functions__button" @click="copy">
            <Icon :icon="'copy'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.addNote"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip effect="light" content="Add" placement="top">
          <el-button class="page-functions__button" @click="addNote">
            <Icon :icon="'add-note'" />
          </el-button>
        </el-tooltip>
        <NoteButton
          v-if="(notes && notes.length) || amountNotes"
          :content="notes && notes.length ? notes.length : '' || amountNotes"
          @clickNoteButton="showAllNotes"
        />
      </li>
      <li
        v-if="activeButtons.pinNote"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip effect="light" content="Pin" placement="top">
          <el-button class="page-functions__button" @click="pinNote">
            <Icon :icon="'pin'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.editNote"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip effect="light" content="Edit" placement="top">
          <el-button class="page-functions__button" @click="editNote">
            <Icon :icon="'edit'" />
          </el-button>
        </el-tooltip>
      </li>
      <li
        v-if="activeButtons.removeNote"
        class="page-functions__item"
        :class="{ 'item-labeled': showLabels }"
      >
        <el-tooltip effect="light" content="Remove" placement="top">
          <el-button class="page-functions__button" @click="removeNote">
            <Icon :icon="'remove'" />
          </el-button>
        </el-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
    Icon: () => import("../elements/Icon"),
    NoteButton: () => import("../elements/NoteButton"),
  },
  props: {
    activeButtons: {
      type: Object,
      default: null,
    },
    orientation: {
      type: String,
      default: "h",
    },
    bookmark: {
      type: Boolean,
      default: false,
    },
    articleTitle: {
      type: String,
      default: "",
    },
    articleNid: {
      type: Number,
      default: null,
    },
    articleAuthor: {
      type: String,
      default: null,
    },
    idForCopy: {
      type: Number,
      default: null,
    },
    idPage: {
      type: [Number, String],
      default: null,
    },
    idSection: {
      type: [Number, String],
      default: null,
    },
    notes: {
      type: Array,
      default: null,
    },
    amountNotes: {
      type: [String, Number],
      default: null,
    },
    showPdf: {
      type: Boolean,
      default: null,
    },
    pageType: {
      type: String,
      default: null,
    },
    forMatomo: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: null,
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    downloadEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      bookmarkChecked: false,
    };
  },
  computed: {
    isBookmark() {
      return this.$store.state.Pages.isBookmark;
    },
    emailUser() {
      return this.$store.state.Profile.dataUser.mail.length
        ? this.$store.state.Profile.dataUser.mail[0].value
        : null;
    },
  },
  watch: {
    notes: {
      deep: true,
      handler(val) {
        this.$store.commit("Dialog/setData", {
          label: "noteList",
          data: this.notes,
        });
      },
    },
  },
  mounted() {
    if (!this.bookmarkChecked && this.articleNid) {
      this.updateBookmark();
    }
  },
  beforeUpdate() {
    if (!this.bookmarkChecked && this.articleNid) {
      this.updateBookmark();
    }
  },
  methods: {
    showAllNotes() {
      this.$emit("getNotes");
      this.$store.commit("Dialog/setData", {
        label: "noteFor",
        data: { page: this.idPage, section: this.idSection },
      });
      this.$store.commit("Dialog/setData", {
        label: "allDialogOpen",
        data: true,
      });
    },

    printPage() {
      this.$emit("clickPdf", this.articleNid);
      if (this.forMatomo) {

        const eventName =
          this.pageType === "data-forecast" ? "downloadData" : "downloadPDF";

        if(this.$matomo) {
          this.$matomo.trackEvent("DownloadPDF", eventName, "", this.articleNid);
        }

        if (this.$churnZero) {
          this.$churnZero.trackEvent("DownloadPDF", eventName);
        }

      }
    },

    pdfDownload() {
      if (this.downloadEnabled) {
        this.$emit("clickPdf", this.articleNid);
        if (this.forMatomo) {

          const eventName =
            this.pageType === "data-forecast" ? "downloadData" : "downloadPDF";

          if (this.$matomo) {
            this.$matomo.trackEvent(
              "DownloadPDF",
              eventName,
              "",
              this.articleNid
            );
          }

          if (this.$churnZero) {
            this.$churnZero.trackEvent("DownloadPDF", eventName);
          }

        }

      }
    },
    excelDownload() {
      if (this.downloadEnabled) {
        this.$emit("clickExcel", this.articleNid);
        if(this.forMatomo) {
          if (this.$matomo) {
            this.$matomo.trackEvent(
              "DownloadExcel",
              "downloadExcel",
              "",
              this.articleNid
            );
          }

          if (this.$churnZero) {
            this.$churnZero.trackEvent("DownloadExcel", "downloadExcel");
          }
        }
      }
    },
    emailToContact() {
      if (this.$matomo) {
        this.$matomo.trackEvent(
          "Engagement Click",
          "Share with contacts",
          this.articleTitle
        );
      }
      if (this.$churnZero) {
        this.$churnZero.trackEvent("Engagement Click", "Share with contacts");
      }
      const url = `Read here: ${window.location.href}`;
      window.open(
        `mailto:${this.emailUser}?subject=${
          this.articleTitle ? this.articleTitle : ""
        }&body=${url}`
      );
    },

    emailToAuthor() {
      if (this.$matomo) {
        console.log("Engagement Click", "Email Author", this.articleTitle);
        this.$matomo.trackEvent(
          "Engagement Click",
          "Email Author",
          this.articleTitle
        );
      }
      if (this.$churnZero) {
        this.$churnZero.trackEvent("Engagement Click", "Email Author");
      }
      const url = `Read here: ${window.location.href}`;
      window.open(
        `mailto:${this.articleAuthor}?subject=${
          this.articleTitle ? this.articleTitle : ""
        }&body=${url}`
      );
    },

    copy() {
      if (process.client) {
        const target2 = document.getElementById(
          `report-section-${this.idForCopy}`
        );
        let rng, sel;
        if (document.createRange) {
          rng = document.createRange();
          rng.selectNode(target2);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(rng);
        } else {
          rng = document.body.createTextRange();
          rng.moveToElementText(target2);
          rng.select();
        }
        document.execCommand("copy");
      }
    },

    checkBookmark() {
      let method = "";
      this.isBookmark ? (method = "DELETE") : (method = "POST");
      const id = this.articleNid;
      const name = this.isBookmark ? "removeBookmark" : "saveBookmark";
      if (this.$matomo) {
        this.$matomo.trackEvent("BookmarkButton", name, "", id);
      }
      if(this.$churnZero) {
        this.$churnZero.trackEvent("BookmarkButton", name);
      }

      if (method === "POST") {
        this.$axios({
          method,
          url: `${this.$config.apiURL}/bookmark`,
          data: {
            nid: id,
          },
        })
          .then((data) => {
            this.updateBookmark();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$axios({
          method,
          url: `${this.$config.apiURL}/bookmark/${id}`,
        })
          .then((data) => {
            this.updateBookmark();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    addNote() {
      this.$store.commit("Dialog/setData", {
        label: "noteFor",
        data: { page: this.idPage, section: this.idSection },
      });
      this.$store.commit("Dialog/setData", {
        label: "dialogTitle",
        data: "Add note",
      });
      this.$store.commit("Dialog/setContent", { label: "addNote", data: true });
      this.$store.commit("Dialog/setData", {
        label: "baseDialogOpen",
        data: true,
      });
    },

    pinNote() {
      this.$emit("pin");
    },

    editNote() {
      this.$emit("edit");
    },

    removeNote() {
      this.$emit("remove");
    },
    updateBookmark() {
      this.bookmarkChecked = true;
      this.$store
        .dispatch("Pages/getData", {
          url: `/bookmark/${this.articleNid}`,
        })
        .then(({ data }) => {
          this.$store.commit("Pages/setData", {
            label: "isBookmark",
            data: data && data.nid,
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.repDownload {
  border: 1px solid #cad8e2 !important;
}

.main ul {
  // list-style-type: none;
  margin-left: 0;
}
.page-functions {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  margin-bottom: 4rem;

  &__list {
    display: flex;
    width: 100%;
    list-style-type: none;

    &--horizontal {
      flex-direction: row;

      .page-functions {
        &__item {
          margin: 0 0.25rem;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }

          &--labeled {
            width: 50%;
            height: 32px;
            //border: 1px solid #cad8e2;
          }
        }
      }
    }

    &--vertical {
      flex-direction: column;

      @include below($md) {
        flex-direction: unset !important;
      }

      .page-functions {
        &__item {
          margin: 0.25rem 0;

          &:first-child {
            margin-top: 0;
          }

          &:last-child {
            margin-bottom: 0;

            @include below($md) {
              margin: 0;
            }
          }
          &.is-labeled {
            border: 1px solid green;
          }
        }
      }
    }

    &--align-right {
      justify-content: flex-end;
      margin-top: 2rem;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.5rem;
    height: 3.5rem;
    position: relative;

    .btn-note {
      position: absolute;
      left: 90%;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none !important;
    margin: 0;
    box-shadow: none;
    padding: 0.5rem;
    transition: $hoverAnim;

    &--disabled {
      // cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
      border: none;
      margin: 0;
      box-shadow: none;
      padding: 0.5rem;
      transition: $hoverAnim;

      .button-label {
        float: right;
        padding-top: 2px;
      }
      .icon {
        width: 2rem;
        height: 2rem;
      }
    }

    .icon {
      width: 2rem;
      height: 2rem;
    }

    &:hover {
      border-color: transparent;
      background-color: transparent;
      opacity: 0.5;
    }

    .button-label {
      float: right;
      padding-top: 2px;
    }
  }
}
</style>
